import {AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PopoverComponent } from '../../popover/popover.component';

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  standalone: true,
  imports: [MaterialModule, FormsModule, CommonModule, PopoverComponent]
})
export class DatatableComponent implements OnChanges, AfterViewInit {
  @Input() companies: any[] = [];
  @ViewChild(MatSort) sort: MatSort;

  dataSource = new MatTableDataSource<any>(this.companies);
  displayedColumns: string[] = ['rank', 'name', 'sector', 'market', 'frequency'];

  filteredCompanies = [];
  selectedLimit = 100;
  listLimits = [
    {
      id: 10,
      name: 'Top 10'
    }, {
      id: 25,
      name: 'Top 25'
    }, {
      id: -1,
      name: 'All'
    }
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.companies) {
      let rank = 1;
      this.companies = changes.companies.currentValue.map((c: any) => {
        c.rank = rank;
        rank++;
        return c;
      });
      this.filteredCompanies = this.limitCompanies(this.companies);
      this.initDatatable();
    }
  }

  limitCompanies(companies) {
    if (this.selectedLimit > 0) {
      return companies.slice(0, this.selectedLimit);
    }
    return companies;
  }

  initDatatable() {
    this.dataSource = new MatTableDataSource<any>(this.filteredCompanies);
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  onLimitChange() {
    this.filteredCompanies = this.limitCompanies(this.companies);
    this.initDatatable();
  }

  closeOtherCompanies(company) {
    this.companies = this.companies.map((c: any) => {
      if (c.id !== company.id) {
        c.isOpen = false;
      }
      return c;
    });
  }
}
